import { FunctionComponent } from 'react'
import ProjectUpdateList from './ProjectUpdateList'

interface ProjectUpdatesInterface {
  projectUpdateApi: string
  projectID: string
}

const ProjectUpdates: FunctionComponent<ProjectUpdatesInterface> = ({
  projectUpdateApi,
  projectID
}) => {
  return (
    <ProjectUpdateList
      projectID={projectID}
      projectUpdateApi={projectUpdateApi}
    />
  )
}

export default ProjectUpdates
